import WebhookModel from './webhook-model';

export default class SendWebhookPreviewModel extends WebhookModel {
    hydrate(
        {
            eventType = null,
            method = 'POST',
            url = 'https://',
            headers = [],
            query = null,
            body = null,
            credentialHash = null,
        } = {},
    ) {
        super.hydrate(
            {
                method,
                url,
                query,
                body,
                headers,
                credentialHash,
            },
        );
        this.eventType = eventType;
    }

    getPayload() {
        const payload = super.getPayload();
        payload.eventType = this.eventType;

        return payload;
    }
}
